// Multi-species config + i18n labels (multi-language).
// prod types: eggs, milk, honey, litter, weight, meat, wool, none.

export const SPECIES = [
  { key: "poules",   emoji: "\uD83D\uDC14", prod: "eggs",   house: "poulailler", cats: ["poules", "coqs", "poulettes", "poussins"] },
  { key: "canards",  emoji: "\uD83E\uDD86", prod: "eggs",   house: "poulailler", cats: ["canes", "canards", "canetons"] },
  { key: "oies",     emoji: "\uD83E\uDEBF", prod: "eggs",   house: "poulailler", cats: ["oies", "jars", "oisons"] },
  { key: "dindes",   emoji: "\uD83E\uDD83", prod: "meat",   house: "poulailler", cats: ["dindes", "dindons", "dindonneaux"] },
  { key: "lapins",   emoji: "\uD83D\uDC07", prod: "litter", house: "clapier",    cats: ["lapines", "lapins", "lapereaux"] },
  { key: "chevres",  emoji: "\uD83D\uDC10", prod: "milk",   house: "chevrerie",  cats: ["chevres", "boucs", "chevreaux"] },
  { key: "moutons",  emoji: "\uD83D\uDC11", prod: "weight", house: "bergerie",   cats: ["brebis", "beliers", "agneaux"] },
  { key: "porcs",    emoji: "\uD83D\uDC16", prod: "weight", house: "porcherie",  cats: ["truies", "verrats", "porcelets"] },
  { key: "bovins",   emoji: "\uD83D\uDC04", prod: "milk",   house: "etable",     cats: ["vaches", "taureaux", "veaux"] },
  { key: "chevaux",  emoji: "\uD83D\uDC0E", prod: "none",   house: "ecurie",     cats: ["juments", "etalons", "poulains"] },
  { key: "abeilles", emoji: "\uD83D\uDC1D", prod: "honey",  house: "rucher",     cats: ["ruches"] },
  { key: "lamas",    emoji: "\uD83E\uDD99", prod: "wool",   house: "enclos",     cats: ["lamas_f", "lamas_m", "cria"] },
];

export const ALL_SPECIES_KEYS = SPECIES.map((s) => s.key);

const SP = {
  "fr": {
    "poules": "Poules",
    "canards": "Canards",
    "oies": "Oies",
    "dindes": "Dindes",
    "lapins": "Lapins",
    "chevres": "Chèvres",
    "moutons": "Moutons",
    "porcs": "Porcs",
    "bovins": "Bovins",
    "chevaux": "Chevaux",
    "abeilles": "Abeilles",
    "lamas": "Lamas & alpagas"
  },
  "en": {
    "poules": "Chickens",
    "canards": "Ducks",
    "oies": "Geese",
    "dindes": "Turkeys",
    "lapins": "Rabbits",
    "chevres": "Goats",
    "moutons": "Sheep",
    "porcs": "Pigs",
    "bovins": "Cattle",
    "chevaux": "Horses",
    "abeilles": "Bees",
    "lamas": "Llamas & alpacas"
  },
  "es": {
    "poules": "Gallinas",
    "canards": "Patos",
    "oies": "Gansos",
    "dindes": "Pavos",
    "lapins": "Conejos",
    "chevres": "Cabras",
    "moutons": "Ovejas",
    "porcs": "Cerdos",
    "bovins": "Bovinos",
    "chevaux": "Caballos",
    "abeilles": "Abejas",
    "lamas": "Llamas y alpacas"
  },
  "it": {
    "poules": "Galline",
    "canards": "Anatre",
    "oies": "Oche",
    "dindes": "Tacchini",
    "lapins": "Conigli",
    "chevres": "Capre",
    "moutons": "Pecore",
    "porcs": "Maiali",
    "bovins": "Bovini",
    "chevaux": "Cavalli",
    "abeilles": "Api",
    "lamas": "Lama e alpaca"
  },
  "de": {
    "poules": "Hühner",
    "canards": "Enten",
    "oies": "Gänse",
    "dindes": "Puten",
    "lapins": "Kaninchen",
    "chevres": "Ziegen",
    "moutons": "Schafe",
    "porcs": "Schweine",
    "bovins": "Rinder",
    "chevaux": "Pferde",
    "abeilles": "Bienen",
    "lamas": "Lamas & Alpakas"
  },
  "nl": {
    "poules": "Kippen",
    "canards": "Eenden",
    "oies": "Ganzen",
    "dindes": "Kalkoenen",
    "lapins": "Konijnen",
    "chevres": "Geiten",
    "moutons": "Schapen",
    "porcs": "Varkens",
    "bovins": "Runderen",
    "chevaux": "Paarden",
    "abeilles": "Bijen",
    "lamas": "Lama's & alpaca's"
  },
  "sv": {
    "poules": "Höns",
    "canards": "Ankor",
    "oies": "Gäss",
    "dindes": "Kalkoner",
    "lapins": "Kaniner",
    "chevres": "Getter",
    "moutons": "Får",
    "porcs": "Grisar",
    "bovins": "Nötkreatur",
    "chevaux": "Hästar",
    "abeilles": "Bin",
    "lamas": "Lamas & alpakor"
  },
  "da": {
    "poules": "Høns",
    "canards": "Ænder",
    "oies": "Gæs",
    "dindes": "Kalkuner",
    "lapins": "Kaniner",
    "chevres": "Geder",
    "moutons": "Får",
    "porcs": "Svin",
    "bovins": "Kvæg",
    "chevaux": "Heste",
    "abeilles": "Bier",
    "lamas": "Lamaer & alpakaer"
  },
  "bg": {
    "poules": "Кокошки",
    "canards": "Патици",
    "oies": "Гъски",
    "dindes": "Пуйки",
    "lapins": "Зайци",
    "chevres": "Кози",
    "moutons": "Овце",
    "porcs": "Свине",
    "bovins": "Говеда",
    "chevaux": "Коне",
    "abeilles": "Пчели",
    "lamas": "Лами & алпаки"
  },
  "el": {
    "poules": "Κότες",
    "canards": "Πάπιες",
    "oies": "Χήνες",
    "dindes": "Γαλοπούλες",
    "lapins": "Κουνέλια",
    "chevres": "Κατσίκες",
    "moutons": "Πρόβατα",
    "porcs": "Χοίροι",
    "bovins": "Βοοειδή",
    "chevaux": "Άλογα",
    "abeilles": "Μέλισσες",
    "lamas": "Λάμα & αλπάκα"
  },
  "hr": {
    "poules": "Kokoši",
    "canards": "Patke",
    "oies": "Guske",
    "dindes": "Purice",
    "lapins": "Kunići",
    "chevres": "Koze",
    "moutons": "Ovce",
    "porcs": "Svinje",
    "bovins": "Goveda",
    "chevaux": "Konji",
    "abeilles": "Pčele",
    "lamas": "Lame i alpake"
  },
  "et": {
    "poules": "Kanad",
    "canards": "Pardid",
    "oies": "Haned",
    "dindes": "Kalkunid",
    "lapins": "Küülikud",
    "chevres": "Kitsed",
    "moutons": "Lambad",
    "porcs": "Sead",
    "bovins": "Veised",
    "chevaux": "Hobused",
    "abeilles": "Mesilased",
    "lamas": "Laamad ja alpakad"
  },
  "fi": {
    "poules": "Kanat",
    "canards": "Ankat",
    "oies": "Hanhet",
    "dindes": "Kalkkunat",
    "lapins": "Kanit",
    "chevres": "Vuohet",
    "moutons": "Lampaat",
    "porcs": "Siat",
    "bovins": "Naudat",
    "chevaux": "Hevoset",
    "abeilles": "Mehiläiset",
    "lamas": "Lamat & alpakat"
  },
  "hu": {
    "poules": "Tyúkok",
    "canards": "Kacsák",
    "oies": "Libák",
    "dindes": "Pulykák",
    "lapins": "Nyulak",
    "chevres": "Kecskék",
    "moutons": "Juhok",
    "porcs": "Sertések",
    "bovins": "Szarvasmarhák",
    "chevaux": "Lovak",
    "abeilles": "Méhek",
    "lamas": "Lámák és alpackák"
  },
  "lv": {
    "poules": "Vistas",
    "canards": "Pīles",
    "oies": "Zosis",
    "dindes": "Tītari",
    "lapins": "Truši",
    "chevres": "Kazas",
    "moutons": "Aitas",
    "porcs": "Cūkas",
    "bovins": "Liellopi",
    "chevaux": "Zirgi",
    "abeilles": "Bites",
    "lamas": "Lamas un alpakas"
  },
  "lt": {
    "poules": "Vištos",
    "canards": "Antys",
    "oies": "Žąsys",
    "dindes": "Kalakutai",
    "lapins": "Triušiai",
    "chevres": "Ožkos",
    "moutons": "Avys",
    "porcs": "Kiaulės",
    "bovins": "Galvijai",
    "chevaux": "Arkliai",
    "abeilles": "Bitės",
    "lamas": "Lamų & alpakų"
  },
  "pl": {
    "poules": "Kury",
    "canards": "Kaczki",
    "oies": "Gęsi",
    "dindes": "Indyki",
    "lapins": "Króliki",
    "chevres": "Kozy",
    "moutons": "Owce",
    "porcs": "Świnie",
    "bovins": "Bydło",
    "chevaux": "Konie",
    "abeilles": "Pszczoły",
    "lamas": "Lamy i alpaki"
  },
  "pt": {
    "poules": "Galinhas",
    "canards": "Patos",
    "oies": "Gansos",
    "dindes": "Perus",
    "lapins": "Coelhos",
    "chevres": "Cabras",
    "moutons": "Ovelhas",
    "porcs": "Porcos",
    "bovins": "Bovinos",
    "chevaux": "Cavalos",
    "abeilles": "Abelhas",
    "lamas": "Lamas & alpacas"
  },
  "ro": {
    "poules": "Găini",
    "canards": "Rațe",
    "oies": "Gâște",
    "dindes": "Curcani",
    "lapins": "Iepuri",
    "chevres": "Capre",
    "moutons": "Oi",
    "porcs": "Porci",
    "bovins": "Bovine",
    "chevaux": "Cai",
    "abeilles": "Albine",
    "lamas": "Lame & alpaca"
  },
  "sk": {
    "poules": "Sliepky",
    "canards": "Kačky",
    "oies": "Husi",
    "dindes": "Morky",
    "lapins": "Králiky",
    "chevres": "Kozy",
    "moutons": "Ovce",
    "porcs": "Ošípané",
    "bovins": "Hovädzí dobytok",
    "chevaux": "Kone",
    "abeilles": "Včely",
    "lamas": "Lamy & alpaky"
  },
  "sl": {
    "poules": "Kokoši",
    "canards": "Race",
    "oies": "Gosi",
    "dindes": "Purani",
    "lapins": "Zajci",
    "chevres": "Koze",
    "moutons": "Ovce",
    "porcs": "Prašiči",
    "bovins": "Govedo",
    "chevaux": "Konji",
    "abeilles": "Čebele",
    "lamas": "Lame in alpake"
  },
  "cs": {
    "poules": "Slepice",
    "canards": "Kachny",
    "oies": "Husy",
    "dindes": "Krůty",
    "lapins": "Králíci",
    "chevres": "Kozy",
    "moutons": "Ovce",
    "porcs": "Prasata",
    "bovins": "Skot",
    "chevaux": "Koně",
    "abeilles": "Včely",
    "lamas": "Lamy a alpaky"
  }
};

const CAT = {
  "fr": {
    "poules": "Poules",
    "coqs": "Coqs",
    "poulettes": "Poulettes",
    "poussins": "Poussins",
    "canes": "Canes",
    "canards": "Canards",
    "canetons": "Canetons",
    "oies": "Oies",
    "jars": "Jars",
    "oisons": "Oisons",
    "dindes": "Dindes",
    "dindons": "Dindons",
    "dindonneaux": "Dindonneaux",
    "lapines": "Lapines",
    "lapins": "Lapins",
    "lapereaux": "Lapereaux",
    "chevres": "Chèvres",
    "boucs": "Boucs",
    "chevreaux": "Chevreaux",
    "brebis": "Brebis",
    "beliers": "Béliers",
    "agneaux": "Agneaux",
    "truies": "Truies",
    "verrats": "Verrats",
    "porcelets": "Porcelets",
    "vaches": "Vaches",
    "taureaux": "Taureaux",
    "veaux": "Veaux",
    "juments": "Juments",
    "etalons": "Étalons",
    "poulains": "Poulains",
    "ruches": "Ruches",
    "lamas_f": "Femelles",
    "lamas_m": "Mâles",
    "cria": "Petits (cria)"
  },
  "en": {
    "poules": "Hens",
    "coqs": "Roosters",
    "poulettes": "Pullets",
    "poussins": "Chicks",
    "canes": "Female ducks",
    "canards": "Drakes",
    "canetons": "Ducklings",
    "oies": "Geese",
    "jars": "Ganders",
    "oisons": "Goslings",
    "dindes": "Hen turkeys",
    "dindons": "Tom turkeys",
    "dindonneaux": "Poults",
    "lapines": "Does",
    "lapins": "Bucks",
    "lapereaux": "Kits",
    "chevres": "Does",
    "boucs": "Bucks",
    "chevreaux": "Kids",
    "brebis": "Ewes",
    "beliers": "Rams",
    "agneaux": "Lambs",
    "truies": "Sows",
    "verrats": "Boars",
    "porcelets": "Piglets",
    "vaches": "Cows",
    "taureaux": "Bulls",
    "veaux": "Calves",
    "juments": "Mares",
    "etalons": "Stallions",
    "poulains": "Foals",
    "ruches": "Hives",
    "lamas_f": "Females",
    "lamas_m": "Males",
    "cria": "Cria (young)"
  },
  "es": {
    "poules": "Gallinas",
    "coqs": "Gallos",
    "poulettes": "Pollitas",
    "poussins": "Pollitos",
    "canes": "Patas",
    "canards": "Patos",
    "canetons": "Patitos",
    "oies": "Gansas",
    "jars": "Gansos",
    "oisons": "Ansarones",
    "dindes": "Pavas",
    "dindons": "Pavos",
    "dindonneaux": "Pavipollos",
    "lapines": "Conejas",
    "lapins": "Conejos",
    "lapereaux": "Gazapos",
    "chevres": "Cabras",
    "boucs": "Machos cabríos",
    "chevreaux": "Cabritos",
    "brebis": "Ovejas",
    "beliers": "Carneros",
    "agneaux": "Corderos",
    "truies": "Cerdas",
    "verrats": "Verracos",
    "porcelets": "Lechones",
    "vaches": "Vacas",
    "taureaux": "Toros",
    "veaux": "Terneros",
    "juments": "Yeguas",
    "etalons": "Sementales",
    "poulains": "Potros",
    "ruches": "Colmenas",
    "lamas_f": "Hembras",
    "lamas_m": "Machos",
    "cria": "Crías"
  },
  "it": {
    "poules": "Galline",
    "coqs": "Galli",
    "poulettes": "Pollastre",
    "poussins": "Pulcini",
    "canes": "Anatre femmine",
    "canards": "Maschi",
    "canetons": "Anatroccoli",
    "oies": "Oche",
    "jars": "Papere maschio",
    "oisons": "Paperi",
    "dindes": "Tacchine",
    "dindons": "Tacchini",
    "dindonneaux": "Tacchinotti",
    "lapines": "Coniglie",
    "lapins": "Conigli",
    "lapereaux": "Coniglietti",
    "chevres": "Capre",
    "boucs": "Becchi",
    "chevreaux": "Capretti",
    "brebis": "Pecore",
    "beliers": "Arieti",
    "agneaux": "Agnelli",
    "truies": "Scrofe",
    "verrats": "Verri",
    "porcelets": "Suinetti",
    "vaches": "Vacche",
    "taureaux": "Tori",
    "veaux": "Vitelli",
    "juments": "Giumente",
    "etalons": "Stalloni",
    "poulains": "Puledri",
    "ruches": "Arnie",
    "lamas_f": "Femmine",
    "lamas_m": "Maschi",
    "cria": "Piccoli"
  },
  "de": {
    "poules": "Hennen",
    "coqs": "Hähne",
    "poulettes": "Junghennen",
    "poussins": "Küken",
    "canes": "Enten (w)",
    "canards": "Erpel",
    "canetons": "Entenküken",
    "oies": "Gänse",
    "jars": "Ganter",
    "oisons": "Gänseküken",
    "dindes": "Puten (w)",
    "dindons": "Puter",
    "dindonneaux": "Putenküken",
    "lapines": "Häsinnen",
    "lapins": "Rammler",
    "lapereaux": "Junge Kaninchen",
    "chevres": "Ziegen",
    "boucs": "Böcke",
    "chevreaux": "Zicklein",
    "brebis": "Mutterschafe",
    "beliers": "Widder",
    "agneaux": "Lämmer",
    "truies": "Sauen",
    "verrats": "Eber",
    "porcelets": "Ferkel",
    "vaches": "Kühe",
    "taureaux": "Bullen",
    "veaux": "Kälber",
    "juments": "Stuten",
    "etalons": "Hengste",
    "poulains": "Fohlen",
    "ruches": "Bienenstöcke",
    "lamas_f": "Weibchen",
    "lamas_m": "Männchen",
    "cria": "Jungtiere"
  },
  "nl": {
    "poules": "Hennen",
    "coqs": "Hanen",
    "poulettes": "Jonge hennen",
    "poussins": "Kuikens",
    "canes": "Vrouwelijke eenden",
    "canards": "Eenden",
    "canetons": "Eendenkuikens",
    "oies": "Ganzen",
    "jars": "Ganders",
    "oisons": "Gansjes",
    "dindes": "Kalkoenhennen",
    "dindons": "Kalkoenhanen",
    "dindonneaux": "Kalkoenpoults",
    "lapines": "Vrouwelijke konijnen",
    "lapins": "Konijnen",
    "lapereaux": "Jonge konijnen",
    "chevres": "Geiten",
    "boucs": "Bokken",
    "chevreaux": "Geitenlammeren",
    "brebis": "Ooien",
    "beliers": "Rammen",
    "agneaux": "Lammeren",
    "truies": "Zeugen",
    "verrats": "Beren",
    "porcelets": "Biggen",
    "vaches": "Koeien",
    "taureaux": "Stieren",
    "veaux": "Kalveren",
    "juments": "Merries",
    "etalons": "Hengsten",
    "poulains": "Veulens",
    "ruches": "Bijenkorven",
    "lamas_f": "Vrouwtjes",
    "lamas_m": "Mannetjes",
    "cria": "Jongen (cria)"
  },
  "sv": {
    "poules": "Hönor",
    "coqs": "Tuppar",
    "poulettes": "Unghönor",
    "poussins": "Kycklingar",
    "canes": "Andhonor",
    "canards": "Anhannar",
    "canetons": "Andungar",
    "oies": "Gäss",
    "jars": "Gångare",
    "oisons": "Gässlingar",
    "dindes": "Kalkoner (honor)",
    "dindons": "Kalkoner (hanar)",
    "dindonneaux": "Kalkonkycklingar",
    "lapines": "Honkaniner",
    "lapins": "Hankaniner",
    "lapereaux": "Kaninungar",
    "chevres": "Getter",
    "boucs": "Bockar",
    "chevreaux": "Killingar",
    "brebis": "Tackor",
    "beliers": "Baggar",
    "agneaux": "Lamm",
    "truies": "Suggor",
    "verrats": "Galtar",
    "porcelets": "Smågrisar",
    "vaches": "Kor",
    "taureaux": "Tjurar",
    "veaux": "Kalvar",
    "juments": "Ston",
    "etalons": "Hingstar",
    "poulains": "Föl",
    "ruches": "Bikupor",
    "lamas_f": "Honor",
    "lamas_m": "Hanar",
    "cria": "Ungar (cria)"
  },
  "da": {
    "poules": "Høns",
    "coqs": "Haner",
    "poulettes": "Unghøns",
    "poussins": "Kyllinger",
    "canes": "Hunænder",
    "canards": "Hananænder",
    "canetons": "Andunger",
    "oies": "Gæs",
    "jars": "Hangæs",
    "oisons": "Gæslinger",
    "dindes": "Kalkunhøner",
    "dindons": "Kalkunhaner",
    "dindonneaux": "Kalkunpoults",
    "lapines": "Hundyr (kanin)",
    "lapins": "Hankalluniner",
    "lapereaux": "Unge kaniner",
    "chevres": "Gedekøer",
    "boucs": "Gedebukke",
    "chevreaux": "Gedekid",
    "brebis": "Moderfår",
    "beliers": "Vædere",
    "agneaux": "Lam",
    "truies": "Søer",
    "verrats": "Orner",
    "porcelets": "Pattegrise",
    "vaches": "Køer",
    "taureaux": "Tyre",
    "veaux": "Kalve",
    "juments": "Hopper",
    "etalons": "Hingste",
    "poulains": "Føl",
    "ruches": "Bistader",
    "lamas_f": "Hunner",
    "lamas_m": "Hanner",
    "cria": "Unger (cria)"
  },
  "bg": {
    "poules": "Кокошки",
    "coqs": "Петли",
    "poulettes": "Юници",
    "poussins": "Пиленца",
    "canes": "Патици (ж)",
    "canards": "Патоци",
    "canetons": "Патенца",
    "oies": "Гъски",
    "jars": "Гъсоци",
    "oisons": "Гъсчета",
    "dindes": "Пуйки",
    "dindons": "Пуяци",
    "dindonneaux": "Пуйчета",
    "lapines": "Зайкини",
    "lapins": "Зайци",
    "lapereaux": "Зайчета",
    "chevres": "Кози",
    "boucs": "Козли",
    "chevreaux": "Козлета",
    "brebis": "Овце",
    "beliers": "Овни",
    "agneaux": "Агнета",
    "truies": "Свине-майки",
    "verrats": "Нерези",
    "porcelets": "Прасенца",
    "vaches": "Крави",
    "taureaux": "Бикове",
    "veaux": "Телета",
    "juments": "Кобили",
    "etalons": "Жребци",
    "poulains": "Жребчета",
    "ruches": "Кошери",
    "lamas_f": "Женски",
    "lamas_m": "Мъжки",
    "cria": "Малки (cria)"
  },
  "el": {
    "poules": "Κότες",
    "coqs": "Κόκορες",
    "poulettes": "Νεαρές κότες",
    "poussins": "Νεοσσοί",
    "canes": "Θηλυκές πάπιες",
    "canards": "Πάπιες",
    "canetons": "Παπάκια",
    "oies": "Χήνες",
    "jars": "Αρσενικές χήνες",
    "oisons": "Νεαρές χήνες",
    "dindes": "Γαλοπούλες",
    "dindons": "Αρσενικές γαλοπούλες",
    "dindonneaux": "Νεαρές γαλοπούλες",
    "lapines": "Θηλυκά κουνέλια",
    "lapins": "Κουνέλια",
    "lapereaux": "Νεαρά κουνέλια",
    "chevres": "Κατσίκες",
    "boucs": "Τράγοι",
    "chevreaux": "Κατσικάκια",
    "brebis": "Προβατίνες",
    "beliers": "Κριάρια",
    "agneaux": "Αρνιά",
    "truies": "Σκρόφες",
    "verrats": "Κάπροι",
    "porcelets": "Χοιρίδια",
    "vaches": "Αγελάδες",
    "taureaux": "Ταύροι",
    "veaux": "Μοσχάρια",
    "juments": "Φοράδες",
    "etalons": "Επιβήτορες",
    "poulains": "Πουλάρια",
    "ruches": "Κυψέλες",
    "lamas_f": "Θηλυκά",
    "lamas_m": "Αρσενικά",
    "cria": "Μικρά (cria)"
  },
  "hr": {
    "poules": "Kokoši",
    "coqs": "Pijetlovi",
    "poulettes": "Mlađe kokoši",
    "poussins": "Pilići",
    "canes": "Patke (ž.)",
    "canards": "Patke (m.)",
    "canetons": "Pačići",
    "oies": "Guske",
    "jars": "Guščevi",
    "oisons": "Guščići",
    "dindes": "Purice",
    "dindons": "Purići (m.)",
    "dindonneaux": "Mladi purići",
    "lapines": "Kunićice",
    "lapins": "Kunići",
    "lapereaux": "Mladi kunići",
    "chevres": "Koze",
    "boucs": "Jarčevi",
    "chevreaux": "Jarad",
    "brebis": "Ovce",
    "beliers": "Ovnovi",
    "agneaux": "Janjad",
    "truies": "Krmače",
    "verrats": "Nerasti",
    "porcelets": "Praščići",
    "vaches": "Krave",
    "taureaux": "Bikovi",
    "veaux": "Telad",
    "juments": "Kobile",
    "etalons": "Pastusi",
    "poulains": "Ždrebad",
    "ruches": "Košnice",
    "lamas_f": "Ženke",
    "lamas_m": "Mužjaci",
    "cria": "Mladunčad (cria)"
  },
  "et": {
    "poules": "Kanad",
    "coqs": "Kukked",
    "poulettes": "Noorkanad",
    "poussins": "Tibud",
    "canes": "Emaspartid",
    "canards": "Isaspartid",
    "canetons": "Parditibud",
    "oies": "Haned",
    "jars": "Isashaned",
    "oisons": "Hanetibud",
    "dindes": "Emaskalkunid",
    "dindons": "Isaskalkunid",
    "dindonneaux": "Kalkunitibud",
    "lapines": "Emasküülikud",
    "lapins": "Isasküülikud",
    "lapereaux": "Küülikupojad",
    "chevres": "Emaskit sed",
    "boucs": "Isaskitsed",
    "chevreaux": "Kitsetalled",
    "brebis": "Ute",
    "beliers": "Jäärad",
    "agneaux": "Talletalled",
    "truies": "Emisid",
    "verrats": "Kuldid",
    "porcelets": "Põrsad",
    "vaches": "Lehmad",
    "taureaux": "Pullid",
    "veaux": "Vasikad",
    "juments": "Märad",
    "etalons": "Täkkud",
    "poulains": "Varsad",
    "ruches": "Mesilaspere",
    "lamas_f": "Emased",
    "lamas_m": "Isased",
    "cria": "Pojad (cria)"
  },
  "fi": {
    "poules": "Kanat",
    "coqs": "Kukot",
    "poulettes": "Nuoret kanat",
    "poussins": "Tiput",
    "canes": "Naarasankat",
    "canards": "Ankat",
    "canetons": "Ankatiput",
    "oies": "Hanhet",
    "jars": "Koirashanhot",
    "oisons": "Hanhenpoikaset",
    "dindes": "Naaraskalkkunat",
    "dindons": "Urokset",
    "dindonneaux": "Kalkkunanpoikaset",
    "lapines": "Naaraskanit",
    "lapins": "Kanit",
    "lapereaux": "Kanipennut",
    "chevres": "Vuohet",
    "boucs": "Pukki",
    "chevreaux": "Vuohenpojat",
    "brebis": "Uuhet",
    "beliers": "Pässit",
    "agneaux": "Karitsat",
    "truies": "Emakot",
    "verrats": "Karjut",
    "porcelets": "Porsaat",
    "vaches": "Lehmät",
    "taureaux": "Sonnit",
    "veaux": "Vasikat",
    "juments": "Tammat",
    "etalons": "Oriit",
    "poulains": "Varsat",
    "ruches": "Mehiläispesät",
    "lamas_f": "Naaraat",
    "lamas_m": "Urokset",
    "cria": "Poikaset (cria)"
  },
  "hu": {
    "poules": "Tyúkok",
    "coqs": "Kakasok",
    "poulettes": "Jércék",
    "poussins": "Csibék",
    "canes": "Tojó kacsák",
    "canards": "Kacsák",
    "canetons": "Kacsafiókák",
    "oies": "Libák",
    "jars": "Gúnárok",
    "oisons": "Libafiókák",
    "dindes": "Pulykák",
    "dindons": "Pulykák (hím)",
    "dindonneaux": "Pulykafiókok",
    "lapines": "Nőstény nyulak",
    "lapins": "Nyulak",
    "lapereaux": "Nyulacskák",
    "chevres": "Kecskék",
    "boucs": "Bakok",
    "chevreaux": "Gidák",
    "brebis": "Anyajuhok",
    "beliers": "Kosok",
    "agneaux": "Bárányok",
    "truies": "Kocák",
    "verrats": "Kandisznók",
    "porcelets": "Malacok",
    "vaches": "Tehenek",
    "taureaux": "Bikák",
    "veaux": "Borjak",
    "juments": "Kancák",
    "etalons": "Mének",
    "poulains": "Csikók",
    "ruches": "Méhkasok",
    "lamas_f": "Nőstények",
    "lamas_m": "Hímek",
    "cria": "Kicsik (cria)"
  },
  "lv": {
    "poules": "Vistas",
    "coqs": "Gaili",
    "poulettes": "Jaunvistas",
    "poussins": "Cāļi",
    "canes": "Pīļu mātītes",
    "canards": "Pīļu tēviņi",
    "canetons": "Pīļu mazuļi",
    "oies": "Zosis",
    "jars": "Zoss tēviņi",
    "oisons": "Zoss mazuļi",
    "dindes": "Tītaru mātītes",
    "dindons": "Tītaru tēviņi",
    "dindonneaux": "Tītaru mazuļi",
    "lapines": "Truša mātītes",
    "lapins": "Truši",
    "lapereaux": "Truša mazuļi",
    "chevres": "Kazas",
    "boucs": "Āži",
    "chevreaux": "Kazu mazuļi",
    "brebis": "Aitas",
    "beliers": "Aunu tēviņi",
    "agneaux": "Jēri",
    "truies": "Sivēnmātes",
    "verrats": "Kuiļi",
    "porcelets": "Sivēni",
    "vaches": "Govis",
    "taureaux": "Vēršu tēviņi",
    "veaux": "Teļi",
    "juments": "Ķēves",
    "etalons": "Ērzeļi",
    "poulains": "Kumeļi",
    "ruches": "Stropi",
    "lamas_f": "Mātītes",
    "lamas_m": "Tēviņi",
    "cria": "Mazuļi (cria)"
  },
  "lt": {
    "poules": "Vištos",
    "coqs": "Gaidžiai",
    "poulettes": "Jaunos vištos",
    "poussins": "Viščiukai",
    "canes": "Antys patelės",
    "canards": "Antys",
    "canetons": "Ančiukai",
    "oies": "Žąsys",
    "jars": "Žąsinai",
    "oisons": "Žąsiukai",
    "dindes": "Kalakutės",
    "dindons": "Kalakutai",
    "dindonneaux": "Jaunikliai",
    "lapines": "Triušės",
    "lapins": "Triušiai",
    "lapereaux": "Jaunikliai",
    "chevres": "Ožkos",
    "boucs": "Ožiai",
    "chevreaux": "Ožiukai",
    "brebis": "Avys",
    "beliers": "Avinai",
    "agneaux": "Ėriukai",
    "truies": "Paršavedės",
    "verrats": "Kuiliai",
    "porcelets": "Paršeliai",
    "vaches": "Karvės",
    "taureaux": "Jaučiai",
    "veaux": "Veršeliai",
    "juments": "Kumelės",
    "etalons": "Eržilai",
    "poulains": "Kumeliukai",
    "ruches": "Aviliai",
    "lamas_f": "Patelės",
    "lamas_m": "Patinai",
    "cria": "Jaunikliai (cria)"
  },
  "pl": {
    "poules": "Kury",
    "coqs": "Koguty",
    "poulettes": "Młode kurki",
    "poussins": "Pisklęta",
    "canes": "Kaczki (samice)",
    "canards": "Kaczki (samce)",
    "canetons": "Kaczątka",
    "oies": "Gęsi",
    "jars": "Gąsiory",
    "oisons": "Gąsięta",
    "dindes": "Indyczki",
    "dindons": "Indyki (samce)",
    "dindonneaux": "Indycząta",
    "lapines": "Królice",
    "lapins": "Króliki",
    "lapereaux": "Młode króliki",
    "chevres": "Kozy",
    "boucs": "Kozły",
    "chevreaux": "Koźlęta",
    "brebis": "Owce (samice)",
    "beliers": "Barany",
    "agneaux": "Jagnięta",
    "truies": "Lochy",
    "verrats": "Knury",
    "porcelets": "Prosięta",
    "vaches": "Krowy",
    "taureaux": "Byki",
    "veaux": "Cielęta",
    "juments": "Klacze",
    "etalons": "Ogiery",
    "poulains": "Źrebięta",
    "ruches": "Ule",
    "lamas_f": "Samice",
    "lamas_m": "Samce",
    "cria": "Młode (cria)"
  },
  "pt": {
    "poules": "Galinhas",
    "coqs": "Galos",
    "poulettes": "Franguinhas",
    "poussins": "Pintos",
    "canes": "Patas",
    "canards": "Patos",
    "canetons": "Patinhos",
    "oies": "Gansos",
    "jars": "Gansaros",
    "oisons": "Gansinhos",
    "dindes": "Perus fêmea",
    "dindons": "Perus",
    "dindonneaux": "Peruinhos",
    "lapines": "Coelhas",
    "lapins": "Coelhos",
    "lapereaux": "Coelhinhos",
    "chevres": "Cabras",
    "boucs": "Bodes",
    "chevreaux": "Cabritos",
    "brebis": "Ovelhas",
    "beliers": "Carneiros",
    "agneaux": "Cordeiros",
    "truies": "Porcas",
    "verrats": "Varrascos",
    "porcelets": "Leitões",
    "vaches": "Vacas",
    "taureaux": "Touros",
    "veaux": "Vitelos",
    "juments": "Éguas",
    "etalons": "Garanhões",
    "poulains": "Potros",
    "ruches": "Colmeias",
    "lamas_f": "Fêmeas",
    "lamas_m": "Machos",
    "cria": "Crias (cria)"
  },
  "ro": {
    "poules": "Găini",
    "coqs": "Cocoși",
    "poulettes": "Puicuțe",
    "poussins": "Pui",
    "canes": "Rațe femele",
    "canards": "Rațe",
    "canetons": "Răcani",
    "oies": "Gâște",
    "jars": "Gâscoi",
    "oisons": "Gâscuțe",
    "dindes": "Curci",
    "dindons": "Curcani",
    "dindonneaux": "Curcănei",
    "lapines": "Iepuroaice",
    "lapins": "Iepuri",
    "lapereaux": "Iepurași",
    "chevres": "Capre",
    "boucs": "Țapi",
    "chevreaux": "Iezi",
    "brebis": "Oi",
    "beliers": "Berbeci",
    "agneaux": "Miei",
    "truies": "Scroafe",
    "verrats": "Vieri",
    "porcelets": "Purcei",
    "vaches": "Vaci",
    "taureaux": "Tauri",
    "veaux": "Viței",
    "juments": "Iepe",
    "etalons": "Armăsari",
    "poulains": "Mânji",
    "ruches": "Stupi",
    "lamas_f": "Femele",
    "lamas_m": "Masculi",
    "cria": "Pui (cria)"
  },
  "sk": {
    "poules": "Sliepky",
    "coqs": "Kohúty",
    "poulettes": "Mladé sliepky",
    "poussins": "Kuriatka",
    "canes": "Kačice",
    "canards": "Kačory",
    "canetons": "Káčatká",
    "oies": "Husi",
    "jars": "Gunáre",
    "oisons": "Húsatká",
    "dindes": "Morky",
    "dindons": "Morčany",
    "dindonneaux": "Mladé morky",
    "lapines": "Samice králikov",
    "lapins": "Králiky",
    "lapereaux": "Mladé králiky",
    "chevres": "Kozy",
    "boucs": "Capi",
    "chevreaux": "Kozľatá",
    "brebis": "Ovce",
    "beliers": "Barany",
    "agneaux": "Jahňatá",
    "truies": "Prasnice",
    "verrats": "Kance",
    "porcelets": "Prasiatka",
    "vaches": "Kravy",
    "taureaux": "Býky",
    "veaux": "Teľatá",
    "juments": "Kobylky",
    "etalons": "Žrebce",
    "poulains": "Žriebätá",
    "ruches": "Úľe",
    "lamas_f": "Samice",
    "lamas_m": "Samce",
    "cria": "Mláďatá (cria)"
  },
  "sl": {
    "poules": "Kokoši",
    "coqs": "Petelini",
    "poulettes": "Mlajše kokoši",
    "poussins": "Piščanci",
    "canes": "Samice race",
    "canards": "Race",
    "canetons": "Račji mladiči",
    "oies": "Gosi",
    "jars": "Samci gosi",
    "oisons": "Gosji mladiči",
    "dindes": "Purice",
    "dindons": "Puranje",
    "dindonneaux": "Puranje mladiči",
    "lapines": "Samice zajcev",
    "lapins": "Zajci",
    "lapereaux": "Zajčki",
    "chevres": "Koze",
    "boucs": "Kozli",
    "chevreaux": "Kozlički",
    "brebis": "Ovce",
    "beliers": "Ovni",
    "agneaux": "Jagnjeta",
    "truies": "Svinje",
    "verrats": "Merjasci",
    "porcelets": "Pujski",
    "vaches": "Krave",
    "taureaux": "Biki",
    "veaux": "Teleta",
    "juments": "Kobile",
    "etalons": "Žrebci",
    "poulains": "Žrebeta",
    "ruches": "Čebelnjaki",
    "lamas_f": "Samice",
    "lamas_m": "Samci",
    "cria": "Mladiči (cria)"
  },
  "cs": {
    "poules": "Slepice",
    "coqs": "Kohouti",
    "poulettes": "Mladé slepice",
    "poussins": "Kuřata",
    "canes": "Kachny samice",
    "canards": "Kachny",
    "canetons": "Kachňata",
    "oies": "Husy",
    "jars": "Husáci",
    "oisons": "Housata",
    "dindes": "Krůty",
    "dindons": "Krocaní",
    "dindonneaux": "Kůzlata krůt",
    "lapines": "Králice",
    "lapins": "Králíci",
    "lapereaux": "Králíčata",
    "chevres": "Kozy",
    "boucs": "Kozli",
    "chevreaux": "Kůzlata",
    "brebis": "Ovce samice",
    "beliers": "Berani",
    "agneaux": "Jehňata",
    "truies": "Prasnice",
    "verrats": "Kanci",
    "porcelets": "Selata",
    "vaches": "Krávy",
    "taureaux": "Býci",
    "veaux": "Telata",
    "juments": "Klisny",
    "etalons": "Hřebci",
    "poulains": "Hříbata",
    "ruches": "Úly",
    "lamas_f": "Samice",
    "lamas_m": "Samci",
    "cria": "Mláďata (cria)"
  }
};

const PROD = {
  "fr": {
    "eggs": [
      "Œufs",
      "unités"
    ],
    "milk": [
      "Lait",
      "litres"
    ],
    "honey": [
      "Miel",
      "kg"
    ],
    "litter": [
      "Portées",
      "petits"
    ],
    "weight": [
      "Poids / croissance",
      "kg"
    ],
    "meat": [
      "Viande",
      "kg"
    ],
    "wool": [
      "Laine / fibre",
      "kg"
    ],
    "none": [
      "Production",
      "unités"
    ]
  },
  "en": {
    "eggs": [
      "Eggs",
      "units"
    ],
    "milk": [
      "Milk",
      "liters"
    ],
    "honey": [
      "Honey",
      "kg"
    ],
    "litter": [
      "Litters",
      "young"
    ],
    "weight": [
      "Weight / growth",
      "kg"
    ],
    "meat": [
      "Meat",
      "kg"
    ],
    "wool": [
      "Wool / fiber",
      "kg"
    ],
    "none": [
      "Production",
      "units"
    ]
  },
  "es": {
    "eggs": [
      "Huevos",
      "unidades"
    ],
    "milk": [
      "Leche",
      "litros"
    ],
    "honey": [
      "Miel",
      "kg"
    ],
    "litter": [
      "Camadas",
      "crías"
    ],
    "weight": [
      "Peso / crecimiento",
      "kg"
    ],
    "meat": [
      "Carne",
      "kg"
    ],
    "wool": [
      "Lana / fibra",
      "kg"
    ],
    "none": [
      "Producción",
      "unidades"
    ]
  },
  "it": {
    "eggs": [
      "Uova",
      "unità"
    ],
    "milk": [
      "Latte",
      "litri"
    ],
    "honey": [
      "Miele",
      "kg"
    ],
    "litter": [
      "Cucciolate",
      "piccoli"
    ],
    "weight": [
      "Peso / crescita",
      "kg"
    ],
    "meat": [
      "Carne",
      "kg"
    ],
    "wool": [
      "Lana / fibra",
      "kg"
    ],
    "none": [
      "Produzione",
      "unità"
    ]
  },
  "de": {
    "eggs": [
      "Eier",
      "Stück"
    ],
    "milk": [
      "Milch",
      "Liter"
    ],
    "honey": [
      "Honig",
      "kg"
    ],
    "litter": [
      "Würfe",
      "Jungtiere"
    ],
    "weight": [
      "Gewicht / Wachstum",
      "kg"
    ],
    "meat": [
      "Fleisch",
      "kg"
    ],
    "wool": [
      "Wolle / Faser",
      "kg"
    ],
    "none": [
      "Produktion",
      "Einheiten"
    ]
  },
  "nl": {
    "eggs": [
      "Eieren",
      "stuks"
    ],
    "milk": [
      "Melk",
      "liter"
    ],
    "honey": [
      "Honing",
      "kg"
    ],
    "litter": [
      "Worpen",
      "jongen"
    ],
    "weight": [
      "Gewicht / groei",
      "kg"
    ],
    "meat": [
      "Vlees",
      "kg"
    ],
    "wool": [
      "Wol / vezel",
      "kg"
    ],
    "none": [
      "Productie",
      "stuks"
    ]
  },
  "sv": {
    "eggs": [
      "Ägg",
      "enheter"
    ],
    "milk": [
      "Mjölk",
      "liter"
    ],
    "honey": [
      "Honung",
      "kg"
    ],
    "litter": [
      "Kullar",
      "ungar"
    ],
    "weight": [
      "Vikt / tillväxt",
      "kg"
    ],
    "meat": [
      "Kött",
      "kg"
    ],
    "wool": [
      "Ull / fiber",
      "kg"
    ],
    "none": [
      "Produktion",
      "enheter"
    ]
  },
  "da": {
    "eggs": [
      "Æg",
      "stk."
    ],
    "milk": [
      "Mælk",
      "liter"
    ],
    "honey": [
      "Honning",
      "kg"
    ],
    "litter": [
      "Kuld",
      "unger"
    ],
    "weight": [
      "Vægt / vækst",
      "kg"
    ],
    "meat": [
      "Kød",
      "kg"
    ],
    "wool": [
      "Uld / fiber",
      "kg"
    ],
    "none": [
      "Produktion",
      "stk."
    ]
  },
  "bg": {
    "eggs": [
      "Яйца",
      "бр."
    ],
    "milk": [
      "Мляко",
      "литри"
    ],
    "honey": [
      "Мед",
      "кг"
    ],
    "litter": [
      "Приплоди",
      "малки"
    ],
    "weight": [
      "Тегло / растеж",
      "кг"
    ],
    "meat": [
      "Месо",
      "кг"
    ],
    "wool": [
      "Вълна / влакно",
      "кг"
    ],
    "none": [
      "Производство",
      "бр."
    ]
  },
  "el": {
    "eggs": [
      "Αυγά",
      "τεμάχια"
    ],
    "milk": [
      "Γάλα",
      "λίτρα"
    ],
    "honey": [
      "Μέλι",
      "kg"
    ],
    "litter": [
      "Γέννες",
      "μικρά"
    ],
    "weight": [
      "Βάρος / ανάπτυξη",
      "kg"
    ],
    "meat": [
      "Κρέας",
      "kg"
    ],
    "wool": [
      "Μαλλί / ίνα",
      "kg"
    ],
    "none": [
      "Παραγωγή",
      "τεμάχια"
    ]
  },
  "hr": {
    "eggs": [
      "Jaja",
      "komada"
    ],
    "milk": [
      "Mlijeko",
      "litara"
    ],
    "honey": [
      "Med",
      "kg"
    ],
    "litter": [
      "Leglo",
      "mladih"
    ],
    "weight": [
      "Težina / rast",
      "kg"
    ],
    "meat": [
      "Meso",
      "kg"
    ],
    "wool": [
      "Vuna / vlakno",
      "kg"
    ],
    "none": [
      "Proizvodnja",
      "jedinica"
    ]
  },
  "et": {
    "eggs": [
      "Munad",
      "tk"
    ],
    "milk": [
      "Piim",
      "liitrit"
    ],
    "honey": [
      "Mesi",
      "kg"
    ],
    "litter": [
      "Pesakonnad",
      "poega"
    ],
    "weight": [
      "Kaal / kasv",
      "kg"
    ],
    "meat": [
      "Liha",
      "kg"
    ],
    "wool": [
      "Vill / kiud",
      "kg"
    ],
    "none": [
      "Toodang",
      "tk"
    ]
  },
  "fi": {
    "eggs": [
      "Munat",
      "kpl"
    ],
    "milk": [
      "Maito",
      "litraa"
    ],
    "honey": [
      "Hunaja",
      "kg"
    ],
    "litter": [
      "Pentueet",
      "poikasta"
    ],
    "weight": [
      "Paino / kasvu",
      "kg"
    ],
    "meat": [
      "Liha",
      "kg"
    ],
    "wool": [
      "Villa / kuitu",
      "kg"
    ],
    "none": [
      "Tuotanto",
      "kpl"
    ]
  },
  "hu": {
    "eggs": [
      "Tojások",
      "darab"
    ],
    "milk": [
      "Tej",
      "liter"
    ],
    "honey": [
      "Méz",
      "kg"
    ],
    "litter": [
      "Almok",
      "kicsi"
    ],
    "weight": [
      "Súly / növekedés",
      "kg"
    ],
    "meat": [
      "Hús",
      "kg"
    ],
    "wool": [
      "Gyapjú / rost",
      "kg"
    ],
    "none": [
      "Termelés",
      "egység"
    ]
  },
  "lv": {
    "eggs": [
      "Olas",
      "gab."
    ],
    "milk": [
      "Piens",
      "litri"
    ],
    "honey": [
      "Medus",
      "kg"
    ],
    "litter": [
      "Metienu",
      "mazuļi"
    ],
    "weight": [
      "Svars / augšana",
      "kg"
    ],
    "meat": [
      "Gaļa",
      "kg"
    ],
    "wool": [
      "Vilna / šķiedra",
      "kg"
    ],
    "none": [
      "Ražošana",
      "gab."
    ]
  },
  "lt": {
    "eggs": [
      "Kiaušiniai",
      "vienetai"
    ],
    "milk": [
      "Pienas",
      "litrai"
    ],
    "honey": [
      "Medus",
      "kg"
    ],
    "litter": [
      "Vadai",
      "jaunikliai"
    ],
    "weight": [
      "Svoris / augimas",
      "kg"
    ],
    "meat": [
      "Mėsa",
      "kg"
    ],
    "wool": [
      "Vilna / pluoštas",
      "kg"
    ],
    "none": [
      "Produkcija",
      "vienetai"
    ]
  },
  "pl": {
    "eggs": [
      "Jaja",
      "szt."
    ],
    "milk": [
      "Mleko",
      "litry"
    ],
    "honey": [
      "Miód",
      "kg"
    ],
    "litter": [
      "Mioty",
      "młode"
    ],
    "weight": [
      "Masa / wzrost",
      "kg"
    ],
    "meat": [
      "Mięso",
      "kg"
    ],
    "wool": [
      "Wełna / włókno",
      "kg"
    ],
    "none": [
      "Produkcja",
      "szt."
    ]
  },
  "pt": {
    "eggs": [
      "Ovos",
      "unidades"
    ],
    "milk": [
      "Leite",
      "litros"
    ],
    "honey": [
      "Mel",
      "kg"
    ],
    "litter": [
      "Ninhadas",
      "crias"
    ],
    "weight": [
      "Peso / crescimento",
      "kg"
    ],
    "meat": [
      "Carne",
      "kg"
    ],
    "wool": [
      "Lã / fibra",
      "kg"
    ],
    "none": [
      "Produção",
      "unidades"
    ]
  },
  "ro": {
    "eggs": [
      "Ouă",
      "unități"
    ],
    "milk": [
      "Lapte",
      "litri"
    ],
    "honey": [
      "Miere",
      "kg"
    ],
    "litter": [
      "Litiere",
      "pui"
    ],
    "weight": [
      "Greutate / creștere",
      "kg"
    ],
    "meat": [
      "Carne",
      "kg"
    ],
    "wool": [
      "Lână / fibră",
      "kg"
    ],
    "none": [
      "Producție",
      "unități"
    ]
  },
  "sk": {
    "eggs": [
      "Vajcia",
      "kusy"
    ],
    "milk": [
      "Mlieko",
      "litre"
    ],
    "honey": [
      "Med",
      "kg"
    ],
    "litter": [
      "Vrhy",
      "mláďatá"
    ],
    "weight": [
      "Hmotnosť / rast",
      "kg"
    ],
    "meat": [
      "Mäso",
      "kg"
    ],
    "wool": [
      "Vlna / vlákno",
      "kg"
    ],
    "none": [
      "Produkcia",
      "kusy"
    ]
  },
  "sl": {
    "eggs": [
      "Jajca",
      "kosov"
    ],
    "milk": [
      "Mleko",
      "litrov"
    ],
    "honey": [
      "Med",
      "kg"
    ],
    "litter": [
      "Legla",
      "mladičev"
    ],
    "weight": [
      "Teža / rast",
      "kg"
    ],
    "meat": [
      "Meso",
      "kg"
    ],
    "wool": [
      "Volna / vlakno",
      "kg"
    ],
    "none": [
      "Proizvodnja",
      "enot"
    ]
  },
  "cs": {
    "eggs": [
      "Vejce",
      "kusů"
    ],
    "milk": [
      "Mléko",
      "litrů"
    ],
    "honey": [
      "Med",
      "kg"
    ],
    "litter": [
      "Vrhy",
      "mláďat"
    ],
    "weight": [
      "Hmotnost / růst",
      "kg"
    ],
    "meat": [
      "Maso",
      "kg"
    ],
    "wool": [
      "Vlna / vlákno",
      "kg"
    ],
    "none": [
      "Produkce",
      "kusů"
    ]
  }
};

const HOUSE = {
  "fr": {
    "poulailler": "Poulailler",
    "chevrerie": "Chèvrerie",
    "bergerie": "Bergerie",
    "porcherie": "Porcherie",
    "etable": "Étable",
    "ecurie": "Écurie",
    "clapier": "Clapier",
    "rucher": "Rucher",
    "enclos": "Enclos",
    "batiments": "Bâtiments"
  },
  "en": {
    "poulailler": "Coop",
    "chevrerie": "Goat barn",
    "bergerie": "Sheepfold",
    "porcherie": "Pigsty",
    "etable": "Cowshed",
    "ecurie": "Stable",
    "clapier": "Rabbit hutch",
    "rucher": "Apiary",
    "enclos": "Enclosure",
    "batiments": "Buildings"
  },
  "es": {
    "poulailler": "Gallinero",
    "chevrerie": "Cabrería",
    "bergerie": "Redil",
    "porcherie": "Pocilga",
    "etable": "Establo",
    "ecurie": "Cuadra",
    "clapier": "Conejera",
    "rucher": "Colmenar",
    "enclos": "Corral",
    "batiments": "Instalaciones"
  },
  "it": {
    "poulailler": "Pollaio",
    "chevrerie": "Capraia",
    "bergerie": "Ovile",
    "porcherie": "Porcile",
    "etable": "Stalla",
    "ecurie": "Scuderia",
    "clapier": "Conigliera",
    "rucher": "Apiario",
    "enclos": "Recinto",
    "batiments": "Edifici"
  },
  "de": {
    "poulailler": "Hühnerstall",
    "chevrerie": "Ziegenstall",
    "bergerie": "Schafstall",
    "porcherie": "Schweinestall",
    "etable": "Kuhstall",
    "ecurie": "Pferdestall",
    "clapier": "Kaninchenstall",
    "rucher": "Bienenstand",
    "enclos": "Gehege",
    "batiments": "Gebäude"
  },
  "nl": {
    "poulailler": "Kippenhok",
    "chevrerie": "Geitenstal",
    "bergerie": "Schaapskooi",
    "porcherie": "Varkensstal",
    "etable": "Koestal",
    "ecurie": "Paardenstal",
    "clapier": "Konijnenhok",
    "rucher": "Bijenstal",
    "enclos": "Omheining",
    "batiments": "Gebouwen"
  },
  "sv": {
    "poulailler": "Hönshus",
    "chevrerie": "Gettstall",
    "bergerie": "Fårstall",
    "porcherie": "Grisstall",
    "etable": "Kostall",
    "ecurie": "Stall",
    "clapier": "Kaningård",
    "rucher": "Bigård",
    "enclos": "Hage",
    "batiments": "Byggnader"
  },
  "da": {
    "poulailler": "Hønsehus",
    "chevrerie": "Gedestald",
    "bergerie": "Fårestald",
    "porcherie": "Svinestald",
    "etable": "Kostald",
    "ecurie": "Hestestald",
    "clapier": "Kaninbur",
    "rucher": "Bistand",
    "enclos": "Indhegning",
    "batiments": "Bygninger"
  },
  "bg": {
    "poulailler": "Кокошарник",
    "chevrerie": "Козарник",
    "bergerie": "Овчарник",
    "porcherie": "Свинарник",
    "etable": "Обор",
    "ecurie": "Конюшня",
    "clapier": "Зайчарник",
    "rucher": "Пчелин",
    "enclos": "Ограда",
    "batiments": "Сгради"
  },
  "el": {
    "poulailler": "Κοτέτσι",
    "chevrerie": "Κατσικοστάσιο",
    "bergerie": "Προβατοστάσιο",
    "porcherie": "Χοιροστάσιο",
    "etable": "Στάβλος",
    "ecurie": "Ιπποστάσιο",
    "clapier": "Κουνελοστάσιο",
    "rucher": "Μελισσοκομείο",
    "enclos": "Περίφραξη",
    "batiments": "Κτήρια"
  },
  "hr": {
    "poulailler": "Kokošinjac",
    "chevrerie": "Kozarnik",
    "bergerie": "Ovčarnik",
    "porcherie": "Svinjac",
    "etable": "Štala",
    "ecurie": "Konjušnica",
    "clapier": "Kuničnjak",
    "rucher": "Pčelinjak",
    "enclos": "Ograda",
    "batiments": "Objekti"
  },
  "et": {
    "poulailler": "Kanala",
    "chevrerie": "Kitsekuur",
    "bergerie": "Lambakuur",
    "porcherie": "Sealaut",
    "etable": "Laut",
    "ecurie": "Tall",
    "clapier": "Küülikukuur",
    "rucher": "Mesila",
    "enclos": "Aed",
    "batiments": "Hooned"
  },
  "fi": {
    "poulailler": "Kanalatalo",
    "chevrerie": "Vuohilatalo",
    "bergerie": "Lampola",
    "porcherie": "Sikala",
    "etable": "Navetta",
    "ecurie": "Talli",
    "clapier": "Kanilatalo",
    "rucher": "Mehiläistarha",
    "enclos": "Aitaus",
    "batiments": "Rakennukset"
  },
  "hu": {
    "poulailler": "Baromfiól",
    "chevrerie": "Kecskeistálló",
    "bergerie": "Juhhodály",
    "porcherie": "Sertésól",
    "etable": "Istálló",
    "ecurie": "Lóistálló",
    "clapier": "Nyúlketrec",
    "rucher": "Méhes",
    "enclos": "Karám",
    "batiments": "Épületek"
  },
  "lv": {
    "poulailler": "Vistas māja",
    "chevrerie": "Kazu kūts",
    "bergerie": "Aitu kūts",
    "porcherie": "Cūku kūts",
    "etable": "Stallī",
    "ecurie": "Zirgu stallis",
    "clapier": "Truša būris",
    "rucher": "Biškopis",
    "enclos": "Aploks",
    "batiments": "Ēkas"
  },
  "lt": {
    "poulailler": "Vištinynas",
    "chevrerie": "Ožkų tvartas",
    "bergerie": "Avių tvartas",
    "porcherie": "Kiaulidė",
    "etable": "Tvartas",
    "ecurie": "Arklidė",
    "clapier": "Triušidė",
    "rucher": "Avilynas",
    "enclos": "Aptvaras",
    "batiments": "Pastatai"
  },
  "pl": {
    "poulailler": "Kurnik",
    "chevrerie": "Koziarnia",
    "bergerie": "Owczarnia",
    "porcherie": "Chlewnia",
    "etable": "Obora",
    "ecurie": "Stajnia",
    "clapier": "Klatka",
    "rucher": "Pasiek",
    "enclos": "Wybieg",
    "batiments": "Budynki"
  },
  "pt": {
    "poulailler": "Galinheiro",
    "chevrerie": "Cabreiro",
    "bergerie": "Aprisco",
    "porcherie": "Pocilga",
    "etable": "Estábulo",
    "ecurie": "Cavalariça",
    "clapier": "Coelheira",
    "rucher": "Apiário",
    "enclos": "Cercado",
    "batiments": "Edifícios"
  },
  "ro": {
    "poulailler": "Găinar",
    "chevrerie": "Caprărie",
    "bergerie": "Stână",
    "porcherie": "Porcărie",
    "etable": "Grajd",
    "ecurie": "Grajd cai",
    "clapier": "Iepurărie",
    "rucher": "Stupărie",
    "enclos": "Țarc",
    "batiments": "Adăposturi"
  },
  "sk": {
    "poulailler": "Kurínok",
    "chevrerie": "Kozinec",
    "bergerie": "Ovčín",
    "porcherie": "Prasačník",
    "etable": "Maštaľ",
    "ecurie": "Stajňa",
    "clapier": "Králikáreň",
    "rucher": "Včelín",
    "enclos": "Ohrada",
    "batiments": "Budovy"
  },
  "sl": {
    "poulailler": "Kokošnjak",
    "chevrerie": "Kozarna",
    "bergerie": "Ovčarnja",
    "porcherie": "Svinjak",
    "etable": "Hlev",
    "ecurie": "Konjušnica",
    "clapier": "Zajčnjak",
    "rucher": "Čebelnjak",
    "enclos": "Ograda",
    "batiments": "Objekti"
  },
  "cs": {
    "poulailler": "Kurník",
    "chevrerie": "Kozinec",
    "bergerie": "Ovčín",
    "porcherie": "Prasečník",
    "etable": "Chlév",
    "ecurie": "Stáj",
    "clapier": "Králikárna",
    "rucher": "Včelín",
    "enclos": "Výběh",
    "batiments": "Budovy"
  }
};

const PFIELD = {
  "fr": {"animalsMilked": "Animaux traites", "moment": "Moment", "morning": "Matin", "evening": "Soir", "yieldPerAnimal": "Rendement / animal", "hivesHarvested": "Ruches récoltées", "honeyType": "Type de miel", "honey_acacia": "Acacia", "honey_wildflower": "Toutes fleurs", "honey_chestnut": "Châtaignier", "honey_linden": "Tilleul", "honey_lavender": "Lavande", "honey_forest": "Forêt / miellat", "honey_other": "Autre", "female": "Mère / femelle", "deadBirth": "Morts à la naissance", "survival": "Taux de survie", "animalsWeighed": "Animaux pesés", "animalsShorn": "Animaux tondus", "animalsCount": "Nombre d'animaux", "details": "Détails", "insightsTitle": "Indicateurs de production (30 j)", "milkYield": "Rendement moyen", "honeyPerHive": "Miel récolté", "literPerAnimal": "L/animal", "kgPerHive": "kg/ruche"},
  "en": {"animalsMilked": "Animals milked", "moment": "Session", "morning": "Morning", "evening": "Evening", "yieldPerAnimal": "Yield / animal", "hivesHarvested": "Hives harvested", "honeyType": "Honey type", "honey_acacia": "Acacia", "honey_wildflower": "Wildflower", "honey_chestnut": "Chestnut", "honey_linden": "Linden", "honey_lavender": "Lavender", "honey_forest": "Forest / honeydew", "honey_other": "Other", "female": "Dam / female", "deadBirth": "Stillbirths", "survival": "Survival rate", "animalsWeighed": "Animals weighed", "animalsShorn": "Animals shorn", "animalsCount": "Animal count", "details": "Details", "insightsTitle": "Production metrics (30 d)", "milkYield": "Average yield", "honeyPerHive": "Honey harvested", "literPerAnimal": "L/animal", "kgPerHive": "kg/hive"},
  "es": {"animalsMilked": "Animales ordeñados", "moment": "Momento", "morning": "Mañana", "evening": "Tarde", "yieldPerAnimal": "Rendimiento / animal", "hivesHarvested": "Colmenas cosechadas", "honeyType": "Tipo de miel", "honey_acacia": "Acacia", "honey_wildflower": "Todas las flores", "honey_chestnut": "Castaño", "honey_linden": "Tilo", "honey_lavender": "Lavanda", "honey_forest": "Bosque / mielato", "honey_other": "Otro", "female": "Madre / hembra", "deadBirth": "Nacidos muertos", "survival": "Tasa de supervivencia", "animalsWeighed": "Animales pesados", "animalsShorn": "Animales esquilados", "animalsCount": "Número de animales", "details": "Detalles", "insightsTitle": "Indicadores de producción (30 d)", "milkYield": "Rendimiento medio", "honeyPerHive": "Miel cosechada", "literPerAnimal": "L/animal", "kgPerHive": "kg/colmena"},
  "it": {"animalsMilked": "Animali munto", "moment": "Momento", "morning": "Mattina", "evening": "Sera", "yieldPerAnimal": "Resa / animale", "hivesHarvested": "Arnie raccolte", "honeyType": "Tipo di miele", "honey_acacia": "Acacia", "honey_wildflower": "Millefiori", "honey_chestnut": "Castagno", "honey_linden": "Tiglio", "honey_lavender": "Lavanda", "honey_forest": "Foresta / melata", "honey_other": "Altro", "female": "Madre / femmina", "deadBirth": "Nati morti", "survival": "Tasso di sopravvivenza", "animalsWeighed": "Animali pesati", "animalsShorn": "Animali tosati", "animalsCount": "Numero di animali", "details": "Dettagli", "insightsTitle": "Indicatori di produzione (30 g)", "milkYield": "Resa media", "honeyPerHive": "Miele raccolto", "literPerAnimal": "L/animale", "kgPerHive": "kg/arnia"},
  "de": {"animalsMilked": "Gemolkene Tiere", "moment": "Zeitpunkt", "morning": "Morgen", "evening": "Abend", "yieldPerAnimal": "Ertrag / Tier", "hivesHarvested": "Geerntete Bienenstöcke", "honeyType": "Honigart", "honey_acacia": "Akazie", "honey_wildflower": "Wildblumen", "honey_chestnut": "Kastanie", "honey_linden": "Linde", "honey_lavender": "Lavendel", "honey_forest": "Wald / Honigtau", "honey_other": "Sonstige", "female": "Mutter / Weibchen", "deadBirth": "Totgeburten", "survival": "Überlebensrate", "animalsWeighed": "Gewogene Tiere", "animalsShorn": "Geschorene Tiere", "animalsCount": "Tieranzahl", "details": "Details", "insightsTitle": "Produktionskennzahlen (30 T)", "milkYield": "Durchschnittsertrag", "honeyPerHive": "Geernteter Honig", "literPerAnimal": "L/Tier", "kgPerHive": "kg/Bienenstock"},
  "nl": {"animalsMilked": "Gemolken dieren", "moment": "Moment", "morning": "Ochtend", "evening": "Avond", "yieldPerAnimal": "Opbrengst / dier", "hivesHarvested": "Geoogste korven", "honeyType": "Honingtype", "honey_acacia": "Acacia", "honey_wildflower": "Veldbloemen", "honey_chestnut": "Kastanje", "honey_linden": "Linde", "honey_lavender": "Lavendel", "honey_forest": "Bos / honingdauw", "honey_other": "Overig", "female": "Moeder / wijfje", "deadBirth": "Doodgeboren", "survival": "Overlevingspercentage", "animalsWeighed": "Gewogen dieren", "animalsShorn": "Geschoren dieren", "animalsCount": "Aantal dieren", "details": "Details", "insightsTitle": "Productie-indicatoren (30 d)", "milkYield": "Gemiddelde opbrengst", "honeyPerHive": "Geoogste honing", "literPerAnimal": "L/dier", "kgPerHive": "kg/korf"},
  "sv": {"animalsMilked": "Mjölkade djur", "moment": "Tidpunkt", "morning": "Morgon", "evening": "Kväll", "yieldPerAnimal": "Avkastning / djur", "hivesHarvested": "Skördade kupor", "honeyType": "Honungstyp", "honey_acacia": "Akacia", "honey_wildflower": "Ängsblomster", "honey_chestnut": "Kastanj", "honey_linden": "Lind", "honey_lavender": "Lavendel", "honey_forest": "Skog / dagghonung", "honey_other": "Annat", "female": "Mor / hona", "deadBirth": "Dödfödda", "survival": "Överlevnadsgrad", "animalsWeighed": "Vägda djur", "animalsShorn": "Klippta djur", "animalsCount": "Antal djur", "details": "Detaljer", "insightsTitle": "Produktionsindikatorer (30 d)", "milkYield": "Genomsnittlig avkastning", "honeyPerHive": "Skördad honung", "literPerAnimal": "L/djur", "kgPerHive": "kg/kupa"},
  "da": {"animalsMilked": "Malkede dyr", "moment": "Tidspunkt", "morning": "Morgen", "evening": "Aften", "yieldPerAnimal": "Udbytte / dyr", "hivesHarvested": "Høstede bistader", "honeyType": "Honningtype", "honey_acacia": "Akacia", "honey_wildflower": "Blomsterhonning", "honey_chestnut": "Kastanje", "honey_linden": "Lind", "honey_lavender": "Lavendel", "honey_forest": "Skov / skovhonning", "honey_other": "Andet", "female": "Mor / hun", "deadBirth": "Dødfødte", "survival": "Overlevelsesrate", "animalsWeighed": "Vejede dyr", "animalsShorn": "Klippe dyr", "animalsCount": "Antal dyr", "details": "Detaljer", "insightsTitle": "Produktionsindikatorer (30 d)", "milkYield": "Gennemsnitligt udbytte", "honeyPerHive": "Høstet honning", "literPerAnimal": "L/dyr", "kgPerHive": "kg/stade"},
  "bg": {"animalsMilked": "Издоени животни", "moment": "Момент", "morning": "Сутрин", "evening": "Вечер", "yieldPerAnimal": "Добив / животно", "hivesHarvested": "Прибрани кошери", "honeyType": "Вид мед", "honey_acacia": "Акация", "honey_wildflower": "Полски цветя", "honey_chestnut": "Кестен", "honey_linden": "Липа", "honey_lavender": "Лавандула", "honey_forest": "Горски / мана", "honey_other": "Друг", "female": "Майка / женска", "deadBirth": "Мъртвородени", "survival": "Преживяемост", "animalsWeighed": "Претеглени животни", "animalsShorn": "Наострижени животни", "animalsCount": "Брой животни", "details": "Детайли", "insightsTitle": "Производствени показатели (30 дни)", "milkYield": "Среден добив", "honeyPerHive": "Добит мед", "literPerAnimal": "л/животно", "kgPerHive": "кг/кошер"},
  "el": {"animalsMilked": "Ζώα που αρμέχτηκαν", "moment": "Στιγμή", "morning": "Πρωί", "evening": "Βράδυ", "yieldPerAnimal": "Απόδοση / ζώο", "hivesHarvested": "Κυψέλες που συγκομίστηκαν", "honeyType": "Τύπος μελιού", "honey_acacia": "Ακακία", "honey_wildflower": "Ανθόμελο", "honey_chestnut": "Καστανιάς", "honey_linden": "Τίλιας", "honey_lavender": "Λεβάντας", "honey_forest": "Δάσους / μελιτώματος", "honey_other": "Άλλο", "female": "Μητέρα / θηλυκό", "deadBirth": "Νεκρά κατά τη γέννηση", "survival": "Ποσοστό επιβίωσης", "animalsWeighed": "Ζώα που ζυγίστηκαν", "animalsShorn": "Ζώα που κουρεύτηκαν", "animalsCount": "Αριθμός ζώων", "details": "Λεπτομέρειες", "insightsTitle": "Δείκτες παραγωγής (30 ημ.)", "milkYield": "Μέση απόδοση", "honeyPerHive": "Μέλι που συγκομίστηκε", "literPerAnimal": "Λ/ζώο", "kgPerHive": "kg/κυψέλη"},
  "hr": {"animalsMilked": "Pomuzene životinje", "moment": "Trenutak", "morning": "Jutro", "evening": "Večer", "yieldPerAnimal": "Prinos / životinja", "hivesHarvested": "Ubrani košnice", "honeyType": "Vrsta meda", "honey_acacia": "Bagrem", "honey_wildflower": "Cvjetni mix", "honey_chestnut": "Kesten", "honey_linden": "Lipa", "honey_lavender": "Lavanda", "honey_forest": "Šumski / medljikovac", "honey_other": "Ostalo", "female": "Majka / ženka", "deadBirth": "Mrtvorođeni", "survival": "Stopa preživljavanja", "animalsWeighed": "Izvagane životinje", "animalsShorn": "Ošišane životinje", "animalsCount": "Broj životinja", "details": "Detalji", "insightsTitle": "Pokazatelji proizvodnje (30 d)", "milkYield": "Prosječni prinos", "honeyPerHive": "Ubrani med", "literPerAnimal": "L/životinja", "kgPerHive": "kg/košnica"},
  "et": {"animalsMilked": "Lüpstud loomad", "moment": "Hetk", "morning": "Hommik", "evening": "Õhtu", "yieldPerAnimal": "Toodang / loom", "hivesHarvested": "Kogutud tarud", "honeyType": "Mee tüüp", "honey_acacia": "Akaatsia", "honey_wildflower": "Metslilled", "honey_chestnut": "Kastan", "honey_linden": "Pärn", "honey_lavender": "Lavendel", "honey_forest": "Mets / mesikaste", "honey_other": "Muu", "female": "Ema / emane", "deadBirth": "Surnult sündinud", "survival": "Elulemus", "animalsWeighed": "Kaalutud loomad", "animalsShorn": "Pügatud loomad", "animalsCount": "Loomade arv", "details": "Üksikasjad", "insightsTitle": "Tootmisnäitajad (30 p)", "milkYield": "Keskmine toodang", "honeyPerHive": "Kogutud mesi", "literPerAnimal": "L/loom", "kgPerHive": "kg/taru"},
  "fi": {"animalsMilked": "Lypsetyt eläimet", "moment": "Ajankohta", "morning": "Aamu", "evening": "Ilta", "yieldPerAnimal": "Tuotto / eläin", "hivesHarvested": "Kerätyt pesät", "honeyType": "Hunajan tyyppi", "honey_acacia": "Akaasia", "honey_wildflower": "Niittykukka", "honey_chestnut": "Kastanja", "honey_linden": "Lehmus", "honey_lavender": "Laventeli", "honey_forest": "Metsä / lehtihunaja", "honey_other": "Muu", "female": "Emä / naaras", "deadBirth": "Kuolleena syntyneet", "survival": "Selviytymisaste", "animalsWeighed": "Punnitut eläimet", "animalsShorn": "Kerityt eläimet", "animalsCount": "Eläinten määrä", "details": "Tiedot", "insightsTitle": "Tuotantomittarit (30 pv)", "milkYield": "Keskimääräinen tuotto", "honeyPerHive": "Kerätty hunaja", "literPerAnimal": "L/eläin", "kgPerHive": "kg/pesä"},
  "hu": {"animalsMilked": "Fejt állatok", "moment": "Időpont", "morning": "Reggel", "evening": "Este", "yieldPerAnimal": "Hozam / állat", "hivesHarvested": "Betakarított kaptárak", "honeyType": "Méz típusa", "honey_acacia": "Akác", "honey_wildflower": "Vegyes virág", "honey_chestnut": "Gesztenye", "honey_linden": "Hárs", "honey_lavender": "Levendula", "honey_forest": "Erdei / harmatméz", "honey_other": "Egyéb", "female": "Anya / nőstény", "deadBirth": "Halvaszületések", "survival": "Túlélési arány", "animalsWeighed": "Mért állatok", "animalsShorn": "Nyírt állatok", "animalsCount": "Állatok száma", "details": "Részletek", "insightsTitle": "Termelési mutatók (30 nap)", "milkYield": "Átlagos hozam", "honeyPerHive": "Betakarított méz", "literPerAnimal": "L/állat", "kgPerHive": "kg/kaptár"},
  "lv": {"animalsMilked": "Slauktie dzīvnieki", "moment": "Moments", "morning": "Rīts", "evening": "Vakars", "yieldPerAnimal": "Raža / dzīvnieks", "hivesHarvested": "Novāktie stropi", "honeyType": "Medus veids", "honey_acacia": "Akāciju", "honey_wildflower": "Savvaļas ziedu", "honey_chestnut": "Kastaņu", "honey_linden": "Liepu", "honey_lavender": "Lavandas", "honey_forest": "Meža / medrasas", "honey_other": "Cits", "female": "Māte / mātīte", "deadBirth": "Miruši piedzimstot", "survival": "Izdzīvošanas līmenis", "animalsWeighed": "Nosvērtie dzīvnieki", "animalsShorn": "Nopļautie dzīvnieki", "animalsCount": "Dzīvnieku skaits", "details": "Detaļas", "insightsTitle": "Ražošanas rādītāji (30 d)", "milkYield": "Vidējā raža", "honeyPerHive": "Novāktais medus", "literPerAnimal": "L/dzīvnieks", "kgPerHive": "kg/strops"},
  "lt": {"animalsMilked": "Melžiami gyvūnai", "moment": "Momentas", "morning": "Rytas", "evening": "Vakaras", "yieldPerAnimal": "Našumas / gyvūnas", "hivesHarvested": "Surinktos aviltys", "honeyType": "Medaus tipas", "honey_acacia": "Akacija", "honey_wildflower": "Visų gėlių", "honey_chestnut": "Kaštonas", "honey_linden": "Liepa", "honey_lavender": "Levanda", "honey_forest": "Miško / medvilnė", "honey_other": "Kita", "female": "Motina / patelė", "deadBirth": "Negyvagimiai", "survival": "Išgyvenamumo rodiklis", "animalsWeighed": "Sverti gyvūnai", "animalsShorn": "Kirpti gyvūnai", "animalsCount": "Gyvūnų skaičius", "details": "Detalės", "insightsTitle": "Gamybos rodikliai (30 d.)", "milkYield": "Vidutinis našumas", "honeyPerHive": "Surinktas medus", "literPerAnimal": "L/gyvūnas", "kgPerHive": "kg/avilys"},
  "pl": {"animalsMilked": "Zwierzęta dojone", "moment": "Moment", "morning": "Rano", "evening": "Wieczór", "yieldPerAnimal": "Wydajność / zwierzę", "hivesHarvested": "Ule zebrane", "honeyType": "Rodzaj miodu", "honey_acacia": "Akacjowy", "honey_wildflower": "Wielokwiatowy", "honey_chestnut": "Kasztanowy", "honey_linden": "Lipowy", "honey_lavender": "Lawendowy", "honey_forest": "Spadziowy", "honey_other": "Inny", "female": "Matka / samica", "deadBirth": "Martwe urodzenia", "survival": "Wskaźnik przeżycia", "animalsWeighed": "Zwierzęta ważone", "animalsShorn": "Zwierzęta strzyżone", "animalsCount": "Liczba zwierząt", "details": "Szczegóły", "insightsTitle": "Wskaźniki produkcji (30 dni)", "milkYield": "Średnia wydajność", "honeyPerHive": "Zebrany miód", "literPerAnimal": "L/zwierzę", "kgPerHive": "kg/ul"},
  "pt": {"animalsMilked": "Animais ordenhados", "moment": "Momento", "morning": "Manhã", "evening": "Tarde", "yieldPerAnimal": "Rendimento / animal", "hivesHarvested": "Colmeias colhidas", "honeyType": "Tipo de mel", "honey_acacia": "Acácia", "honey_wildflower": "Multifloral", "honey_chestnut": "Castanheiro", "honey_linden": "Tília", "honey_lavender": "Lavanda", "honey_forest": "Floresta / melada", "honey_other": "Outro", "female": "Mãe / fêmea", "deadBirth": "Natimortos", "survival": "Taxa de sobrevivência", "animalsWeighed": "Animais pesados", "animalsShorn": "Animais tosquiados", "animalsCount": "Número de animais", "details": "Detalhes", "insightsTitle": "Indicadores de produção (30 d)", "milkYield": "Rendimento médio", "honeyPerHive": "Mel colhido", "literPerAnimal": "L/animal", "kgPerHive": "kg/colmeia"},
  "ro": {"animalsMilked": "Animale mulse", "moment": "Moment", "morning": "Dimineață", "evening": "Seară", "yieldPerAnimal": "Randament / animal", "hivesHarvested": "Stupi recoltați", "honeyType": "Tip de miere", "honey_acacia": "Salcâm", "honey_wildflower": "Flori de câmp", "honey_chestnut": "Castan", "honey_linden": "Tei", "honey_lavender": "Lavandă", "honey_forest": "Pădure / mană", "honey_other": "Altul", "female": "Mamă / femelă", "deadBirth": "Născuți morți", "survival": "Rată de supraviețuire", "animalsWeighed": "Animale cântărite", "animalsShorn": "Animale tunse", "animalsCount": "Număr de animale", "details": "Detalii", "insightsTitle": "Indicatori de producție (30 z)", "milkYield": "Randament mediu", "honeyPerHive": "Miere recoltată", "literPerAnimal": "L/animal", "kgPerHive": "kg/stup"},
  "sk": {"animalsMilked": "Dojené zvieratá", "moment": "Moment", "morning": "Ráno", "evening": "Večer", "yieldPerAnimal": "Výnos / zviera", "hivesHarvested": "Zozbierané úle", "honeyType": "Typ medu", "honey_acacia": "Agát", "honey_wildflower": "Lúčny med", "honey_chestnut": "Gaštanový", "honey_linden": "Lipový", "honey_lavender": "Levanduľový", "honey_forest": "Lesný / medovicový", "honey_other": "Iný", "female": "Matka / samica", "deadBirth": "Mŕtvo narodené", "survival": "Miera prežitia", "animalsWeighed": "Zvážené zvieratá", "animalsShorn": "Ostrihané zvieratá", "animalsCount": "Počet zvierat", "details": "Podrobnosti", "insightsTitle": "Produkčné ukazovatele (30 d)", "milkYield": "Priemerný výnos", "honeyPerHive": "Zozbieraný med", "literPerAnimal": "l/zviera", "kgPerHive": "kg/úľ"},
  "sl": {"animalsMilked": "Molzene živali", "moment": "Čas", "morning": "Jutro", "evening": "Večer", "yieldPerAnimal": "Donos / žival", "hivesHarvested": "Panje pobrani", "honeyType": "Vrsta medu", "honey_acacia": "Akacija", "honey_wildflower": "Vse rože", "honey_chestnut": "Kostanj", "honey_linden": "Lipa", "honey_lavender": "Sivka", "honey_forest": "Gozd / medena rosa", "honey_other": "Drugo", "female": "Mati / samica", "deadBirth": "Mrtvorojeni", "survival": "Stopnja preživetja", "animalsWeighed": "Stehtane živali", "animalsShorn": "Strižene živali", "animalsCount": "Število živali", "details": "Podrobnosti", "insightsTitle": "Kazalniki proizvodnje (30 dni)", "milkYield": "Povprečni donos", "honeyPerHive": "Pobran med", "literPerAnimal": "L/žival", "kgPerHive": "kg/panj"},
  "cs": {"animalsMilked": "Dojená zvířata", "moment": "Moment", "morning": "Ráno", "evening": "Večer", "yieldPerAnimal": "Výnos / zvíře", "hivesHarvested": "Sklizené úly", "honeyType": "Typ medu", "honey_acacia": "Akát", "honey_wildflower": "Luční květ", "honey_chestnut": "Kaštan", "honey_linden": "Lípa", "honey_lavender": "Levandule", "honey_forest": "Les / medovice", "honey_other": "Jiný", "female": "Matka / samice", "deadBirth": "Mrtvě narozená", "survival": "Míra přežití", "animalsWeighed": "Vážená zvířata", "animalsShorn": "Ostříhaná zvířata", "animalsCount": "Počet zvířat", "details": "Podrobnosti", "insightsTitle": "Výrobní ukazatele (30 d)", "milkYield": "Průměrný výnos", "honeyPerHive": "Sklizený med", "literPerAnimal": "l/zvíře", "kgPerHive": "kg/úl"},
};

const L = (lang) => (SP[lang] ? lang : "fr");

export const housingLabel = (lang, keys) => {
  const types = [...new Set((keys || []).map((k) => speciesByKey(k)?.house).filter(Boolean))];
  const M = HOUSE[L(lang)] || HOUSE.fr;
  return types.length === 1 ? (M[types[0]] || M.batiments) : M.batiments;
};
export const spLabel = (lang, key) => (SP[L(lang)][key] || key);
export const catLabel = (lang, key) => (CAT[L(lang)][key] || key);
export const prodLabel = (lang, p) => (PROD[L(lang)][p] || PROD.fr[p] || PROD.fr.none)[0];
export const prodUnit = (lang, p) => (PROD[L(lang)][p] || PROD.fr[p] || PROD.fr.none)[1];
export const speciesByKey = (key) => SPECIES.find((s) => s.key === key);

export const PROD_FIELDS = {
  milk: [
    { key: "animals_milked", labelKey: "animalsMilked", type: "number" },
    { key: "moment", labelKey: "moment", type: "select", options: [
      { value: "morning", labelKey: "morning" }, { value: "evening", labelKey: "evening" } ] },
  ],
  honey: [
    { key: "hives_harvested", labelKey: "hivesHarvested", type: "number" },
    { key: "honey_type", labelKey: "honeyType", type: "select", options: [
      { value: "acacia", labelKey: "honey_acacia" }, { value: "wildflower", labelKey: "honey_wildflower" },
      { value: "chestnut", labelKey: "honey_chestnut" }, { value: "linden", labelKey: "honey_linden" },
      { value: "lavender", labelKey: "honey_lavender" }, { value: "forest", labelKey: "honey_forest" },
      { value: "other", labelKey: "honey_other" } ] },
  ],
  litter: [
    { key: "female", labelKey: "female", type: "text" },
    { key: "dead_birth", labelKey: "deadBirth", type: "number" },
  ],
  weight: [ { key: "animals_weighed", labelKey: "animalsWeighed", type: "number" } ],
  wool: [ { key: "animals_shorn", labelKey: "animalsShorn", type: "number" } ],
  meat: [ { key: "animals_count", labelKey: "animalsCount", type: "number" } ],
  eggs: [],
  none: [],
};

export const pfield = (lang, key) => (PFIELD[L(lang)] || PFIELD.fr)[key] || PFIELD.fr[key] || key;
